export default __webpack_public_path__ + "static/media/Ellipse 37.960c88f6.png";